import { useMemo } from 'react';

import type { EditorState } from '@atlaskit/editor-prosemirror/state';

// eslint-disable-next-line import/order
import { getRovoAgentsPluginState } from '../../pm-plugins/rovo-agents/plugin-factory';
import type { RovoAgentsPluginState } from './states';

type UseAgentProps = {
	editorState: EditorState;
};

/**
 * A memoized getter for rovo plugin state (enabled, agents, etc).
 */
export function useAgents({ editorState }: UseAgentProps): RovoAgentsPluginState | undefined {
	const pluginState = useMemo(() => {
		const rovoAgentsPluginState = getRovoAgentsPluginState(editorState);
		return rovoAgentsPluginState;
	}, [editorState]);

	return pluginState;
}
